import React from 'react';
import Styles from './EmprestimoGarantiaCarroContratoComoFez.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import CustomEmblaCarouselHome24 from '../CustomEmblaCarouselHome24';
import { isMobile } from '@/utils/browser';
import RedButton from '@/components/atoms/RedButton';
import WhiteButton from '@/components/atoms/WhiteButton';

function EmprestimoGarantiaCarroContratoComoFez() {
  return (
    <section id="emp-garantica-como-fez-contrato">
      <ContainerHome24>
        <h2 className="title-contrato">Como você fez seu contrato?</h2>
        <p className="text-contrato">
          Para acessar , primeiro escolha entre as opções abaixo como ele foi feito:
        </p>
      </ContainerHome24>
      <div className="row">
        <div className="box-contrato">
          <img
            src="assets/emprestimo-garantia-carro-contrato/ic_bank.png"
            alt="icone banco santander"
          />
          <h4>Com gerente ou lojista parceiro</h4>
          <p>
            Caso seu contrato tenha sido feito com um gerente Santander ou lojista de uma loja
            parceira.
          </p>
          <RedButton
            href="https://www.santanderfinanciamentos.com.br/spa-mktfinweb/#/login"
            className="btn-red"
            target="_blank"
          >
            Acessar contrato
          </RedButton>
        </div>

        <div className="box-contrato">
          <img
            src="assets/emprestimo-garantia-carro-contrato/ic_stnd.png"
            alt="icone banco santander"
          />
          <h4>Via site ou aplicativo</h4>
          <p>Caso seu contrato tenha sido feito via site ou aplicativo, sem intermediários.</p>
          <WhiteButton
            href="https://emprestimosim.com.br/app/#/login/signInPre"
            className="btn-white"
            target="_blank"
          >
            Acessar contrato
          </WhiteButton>
        </div>
      </div>

      <style jsx>{Styles}</style>
    </section>
  );
}

export default EmprestimoGarantiaCarroContratoComoFez;
